import { AxiosResponse } from "axios";
import { _aiTraceAsError, _get, _post } from "./BaseApiService";

const WORKER_TIME_RECORD_API = "WorkerTimeRecord";

export interface WorkerTimeRecordPayload {
    id: number;
    workerTimeRecordTypeId: string;
    workerTimeRecordType: string;
    workerTimeRecordStatusId: string;
    workerTimeRecordStatus: string;
    clientId: string;
    venueId: string;
    venueHouseNumber: string;
    venueName: string;
    contactId: string;
    contactName: string;
    contactMobileTelephone: string;
    businessEntityId: string;
    businessEntityShortName: string;
    serviceTypeLookUpId: string;
    serviceTypeLookUp: string;
    serviceSubTypeLookUpId: string;
    serviceSubTypeLookUp: string;
    typeLookUpId: string;
    typeLookUp: string;
    relatedId: string;
    startTime: string;
    finishTime: string;
    name: string;
    idValue: string;
    extTimeRecordId: string;
    extUserId: string;
    extUserName: string;
    extVenueId: string;
    extVenueName: string;
    extService: string;
    description: string | null;
    internalComments: string;
    lastUpdatedOn: string;
    lastUpdatedBy: string;
}

class WorkerTimeRecordService {
    /**
     * Retrieves one worker time record by identifier.
     */
    getWorkerTimeRecord(id: string | number): Promise<AxiosResponse<any>> {
        return _get(`${WORKER_TIME_RECORD_API}/${encodeURIComponent(String(id))}`);
    }

    /**
     * Retrieves worker time records for a date and venue.
     */
    getWorkerTimeRecords(date: string, venueId: string): Promise<AxiosResponse<any>> {
        const params = new URLSearchParams({ date, venueId }).toString();
        return _get(`${WORKER_TIME_RECORD_API}?${params}`);
    }

    /**
     * Retrieves incomplete worker time records for the supplied filters.
     */
    getIncompleteWorkerTimeRecords(
        dateFrom: string,
        serviceId: string,
        venueId: string,
        providerId: string,
        clientId: string
    ): Promise<AxiosResponse<any>> {
        const params = new URLSearchParams({ dateFrom, serviceId, venueId, providerId, clientId }).toString();
        return _get(`${WORKER_TIME_RECORD_API}/Incomplete?${params}`);
    }

    /**
     * Creates a worker time record using the API payload contract.
     */
    createWorkerTimeRecord(payload: WorkerTimeRecordPayload): Promise<AxiosResponse<any>> {
        return _post(WORKER_TIME_RECORD_API, payload);
    }

    /**
     * Forwards service errors to AppInsights when available.
     */
    traceAsErrorToAppInsights(message: string): boolean {
        return _aiTraceAsError(message);
    }
}

export default WorkerTimeRecordService;
